import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as LinkIcon, Warning as WarningIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type QuestionConditionButtonBadgesProps = {
  conditionsCount: number;
  dependentCount: number;
  invalidCount: number;
};

export const QuestionConditionButtonBadges: React.FC<
  QuestionConditionButtonBadgesProps
> = ({ conditionsCount, dependentCount, invalidCount }) => {
  const { t } = useTranslation();

  const badges = [];

  if (conditionsCount > 0) {
    badges.push(
      <Box
        key="conditions"
        component="span"
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <Typography
          component="span"
          variant="caption"
          sx={{ color: 'primary.main', fontWeight: 500 }}
        >
          {conditionsCount}{' '}
          {t('pages.studies.questions.conditions.displayConditionsTab')}
        </Typography>
      </Box>,
    );
  }

  if (dependentCount > 0) {
    if (badges.length > 0) {
      badges.push(
        <Box
          key="divider1"
          component="span"
          sx={{
            width: '1px',
            height: '16px',
            backgroundColor: 'divider',
          }}
        />,
      );
    }
    badges.push(
      <Box
        key="dependent"
        component="span"
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <LinkIcon sx={{ fontSize: 16, color: 'secondary.main' }} />
        <Typography
          component="span"
          variant="caption"
          sx={{ color: 'secondary.main', fontWeight: 500 }}
        >
          {t('pages.studies.questions.conditions.usedInConditions', {
            count: dependentCount,
          })}
        </Typography>
      </Box>,
    );
  }

  if (invalidCount > 0) {
    if (badges.length > 0) {
      badges.push(
        <Box
          key="divider2"
          component="span"
          sx={{
            width: '1px',
            height: '16px',
            backgroundColor: 'divider',
          }}
        />,
      );
    }
    badges.push(
      <Box
        key="invalid"
        component="span"
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <WarningIcon sx={{ fontSize: 16, color: 'error.main' }} />
        <Typography
          component="span"
          variant="caption"
          sx={{ color: 'error.main', fontWeight: 500 }}
        >
          {t('pages.studies.questions.conditions.invalidConditionsLabel', {
            count: invalidCount,
          })}
        </Typography>
      </Box>,
    );
  }

  return (
    <Box
      component="span"
      sx={{
        ml: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {badges}
    </Box>
  );
};
